import { Box, ButtonBase, Typography } from "@mui/material";

import type { HomeFilterKey } from "../types/home.types";
import { HOME_CARD_SHADOW, HOME_COLORS } from "./homeTheme";

export interface CountTile {
  key: HomeFilterKey;
  title: string;
  support: string;
  value?: number;
}

interface CountTilesProps {
  tiles: CountTile[];
  onOpen(key: HomeFilterKey): void;
}

/** Linha de contadores clicáveis (Pós-evento, Perdas e cancelamentos). */
export function CountTiles({ tiles, onOpen }: CountTilesProps) {
  return (
    <Box
      display="grid"
      gap={2}
      gridTemplateColumns="repeat(auto-fit, minmax(220px, 1fr))"
    >
      {tiles.map(({ key, title, support, value }) => (
        <ButtonBase
          key={key}
          onClick={() => onOpen(key)}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 2,
            p: 2,
            textAlign: "left",
            bgcolor: "#FFF",
            borderRadius: "8px",
            border: `1px solid ${HOME_COLORS.line}`,
            boxShadow: HOME_CARD_SHADOW,
            "&:hover": { borderColor: HOME_COLORS.primary },
          }}
        >
          <Typography sx={{ fontSize: 26, fontWeight: 700, minWidth: 40 }}>
            {value ?? "–"}
          </Typography>
          <Box display="flex" flexDirection="column">
            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
              {title}
            </Typography>
            <Typography sx={{ fontSize: 12, color: HOME_COLORS.muted }}>
              {support}
            </Typography>
          </Box>
        </ButtonBase>
      ))}
    </Box>
  );
}
